import axios from "axios";
import { toast } from "@/components/ui/use-toast";
import { defaultHeader } from "../../constants/defaultItems";
import { DESTINATION_OPTIONS } from "../../reducers/types";

export const searchTourPackages = (destinationId, pageSize, pageNo, month, callback) => (dispatch) => {
  // Always include month in API call, default to "0" if not provided
  const monthParam = month || "0";
  const url = `/api/Tour/Search/?destination=${destinationId}&pageSize=${pageSize}&pageNo=${pageNo}&month=${monthParam}`;

  axios.get(url, defaultHeader)
    .then(function (resp) {
      if (resp.data.IsSuccess) {
        callback && callback(resp.data);
      } else {
        toast({
          variant: "destructive",
          title: "Error",
          description: resp.data?.Message ?? "Failed to fetch tour packages"
        })
        callback && callback(null);
      }
    }).catch(function (error) {
      toast({
        variant: "destructive",
        title: error.name,
        description: error.message
      })
    })
}

export const getDestinationOptions = () => (dispatch) => {
  axios.get(`/api/Tour/DestinationOptions`, defaultHeader)
    .then(function (resp) {
      if (resp.data.IsSuccess) {
        dispatch({ type: DESTINATION_OPTIONS, payload: resp.data.Result })
      } else {
        toast({
          variant: "destructive",
          title: "Error",
          description: resp.data?.Message ?? "Failed to fetch tour packages"
        })
      }
    }).catch(function (error) {
      toast({
        variant: "destructive",
        title: error.name,
        description: error.message
      })
    })
}

export const getTourPackageDetail = (packageId, callback) => {
  axios.get(`/api/Tour/PackageDetail?packageId=${packageId}`, defaultHeader)
    .then(function (resp) {
      if (resp.data.IsSuccess) {
        callback && callback(resp.data.Result);
      } else {
        toast({
          variant: "destructive",
          title: "Error",
          description: resp.data?.Message ?? "Failed to fetch tour package detail"
        })
        callback && callback(null);
      }
    }).catch(function (error) {
      toast({
        variant: "destructive",
        title: error.name,
        description: error.message
      })
    })
}

export const getPopularDestinations = (callback) => {
  axios.get(`/api/Tour/PopularDestinations`, defaultHeader)
    .then(function (resp) {
      if (resp.data.IsSuccess) {
        callback && callback(resp.data.Result);
      } else {
        toast({
          variant: "destructive",
          title: "Error",
          description: resp.data?.Message ?? "Failed to fetch popular destinations"
        })
        callback && callback(null);
      }
    }).catch(function (error) {
      toast({
        variant: "destructive",
        title: error.name,
        description: error.message
      })
    })
}

export const getPopularPackages = (callback) => {
  axios.get(`/api/Tour/PopularPackages`, defaultHeader)
    .then(function (resp) {
      if (resp.data.IsSuccess) {
        callback && callback(resp.data.Result);
      } else {
        toast({
          variant: "destructive",
          title: "Error",
          description: resp.data?.Message ?? "Failed to fetch popular packages"
        })
        callback && callback(null);
      }
    }).catch(function (error) {
      toast({
        variant: "destructive",
        title: error.name,
        description: error.message
      })
    })
}

export const getPackageforDestination = (destinationId, callback) => {
  axios.get(`/api/Tour/PackageforDestination?destinationId=${destinationId}`, defaultHeader)
    .then(function (resp) {
      if (resp.data.IsSuccess) {
        callback && callback(resp.data.Result);
      } else {
        toast({
          variant: "destructive",
          title: "Error",
          description: resp.data?.Message ?? "Failed to fetch packages for destination"
        })
        callback && callback(null);
      }
    }).catch(function (error) {
      toast({
        variant: "destructive",
        title: error.name,
        description: error.message
      })
    })
}

export const getTourAvailPrice = (packageId, callback) => {
  axios.get(`/api/Tour/AvailPriceAll?packageId=${packageId}`, defaultHeader)
    .then(function (resp) {
      if (resp.data.IsSuccess) {
        callback && callback(resp.data.Result);
      } else {
        toast({
          variant: "destructive",
          title: "Error",
          description: resp.data?.Message ?? "Failed to fetch tour package available price"
        })
        callback && callback(null);
      }
    }).catch(function (error) {
      toast({
        variant: "destructive",
        title: error.name,
        description: error.message
      })
    })
}

export const bookTourPackage = (bookingData, callback) => (dispatch) => {
  axios.post(`/api/Tour/BookPackage`, bookingData, defaultHeader)
    .then(function (resp) {
      if (resp.data.IsSuccess) {
        callback && callback(resp.data);
      } else {
        toast({
          variant: "destructive",
          title: "Booking Error",
          description: resp.data?.Message ?? "Failed to book package"
        })
        callback && callback(resp.data);
      }
    }).catch(function (error) {
      console.error("Booking API Error:", error);
      const errorMessage = error.response?.data?.Message || error.response?.data?.message || error.message || "An unexpected error occurred";
      toast({
        variant: "destructive",
        title: "Booking Failed",
        description: errorMessage
      })
      callback && callback({ IsSuccess: false, Message: errorMessage });
    })
}

export const getMyTourBookings = (offset, limit, keywords, callback) => (dispatch) => {
  axios.get(`/api/Tour/GetBooking/?offset=${offset ?? 0}&limit=${limit ?? 10}&keywords=${keywords || ""}`, defaultHeader).then((resp) => {
    callback && callback(resp.data.Result || resp.data.Results || []);
  }).catch((error) => {
    console.error("Fetch Tour Bookings Error:", error);
    callback && callback([]);
  });
};

export const getBookingDetail = (bookUID, callback) => (dispatch) => {
  axios.get(`/api/Tour/GetBookingDetail?bookUID=${bookUID}`, defaultHeader)
    .then(function (resp) {
      if (resp.data.IsSuccess) {
        callback && callback(resp.data.Result);
        //console.log(resp.data.Result);
        console.log("Data fetched successfully");
      } else {
        toast({
          variant: "destructive",
          title: "Error",
          description: resp.data?.Message ?? "Failed to fetch booking detail"
        })
        callback && callback(null);
      }
    }).catch(function (error) {
      toast({
        variant: "destructive",
        title: error.name,
        description: error.message
      })
    })
};

export const sendBookingEmail = (emailData, callback) => (dispatch) => {
  axios.post(`/api/Tour/SendBookingEmail`, emailData, defaultHeader)
    .then(function (resp) {
      if (resp.data.IsSuccess) {
        toast({
          variant: "success",
          title: "Email Sent",
          description: resp.data?.Message ?? "Email sent successfully"
        })
        callback && callback(resp.data);
      } else {
        toast({
          variant: "destructive",
          title: "Email Failed",
          description: resp.data?.Message ?? "Failed to send email"
        })
        callback && callback(resp.data);
      }
    }).catch(function (error) {
      toast({
        variant: "destructive",
        title: error.name,
        description: error.message
      })
      callback && callback({ IsSuccess: false, Message: error.message });
    });
};

export const updateBookingAfterPayment = (bookingData, callback) => (dispatch) => {
  const { tourBookID, bookUID, packageID, tourPricingID } = bookingData;
  const url = `/api/Tour/UpdateBookingAfterPayment?tourBookID=${tourBookID}&bookUID=${bookUID}&packageID=${packageID}&tourPricingID=${tourPricingID}`;
  
  axios.post(url, {}, defaultHeader)
    .then(function (resp) {
      if (resp.data.IsSuccess) {
        callback && callback(resp.data);
      } else {
        toast({
          variant: "destructive",
          title: "Update Error",
          description: resp.data?.Message ?? "Failed to update booking status"
        })
        callback && callback(resp.data);
      }
    }).catch(function (error) {
      console.error("Update Status API Error:", error);
      toast({
        variant: "destructive",
        title: "Update Failed",
        description: error.message
      })
      callback && callback({ IsSuccess: false, Message: error.message });
    });
};

